import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const TimeSeriesDashboard = () => {
  return <DashboardPageTemplate pageName={"timeSeries"} />;
};
